import { Component } from '@angular/core';
import {Events, IonicPage, ModalController, NavController, NavParams, PopoverController} from 'ionic-angular';
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import * as moment from "moment";
import {UserStats} from "../../providers/api-course-data/user-state-dto";
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";

/**
 * Generated class for the AppMoodUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-mood-update',
  templateUrl: 'app-mood-update.html',
})
export class AppMoodUpdatePage {

  chosenMood:number;

  selectedDateFormatted: string;
  selectedDate: Date = new Date();
  minDate: Date = new Date(2018,1,1);
  maxDate: Date = new Date();
  errorVisible: boolean;
  private moodDetails: Map<number, string>;
  private moodFeedback: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public modalCtrl: ModalController, private stats: UserStatsProvider, private progress: UserProgressStateProvider, public contentTranslation: ContentTranslationProvider, public popoverCtrl: PopoverController, private events: Events) {
    moment.updateLocale('de',function() {

    });
    this.selectedDateFormatted = moment().format('dd, ll')

    if(this.navParams.get('date')) {
      this.selectedDate = moment(this.navParams.get('date')).toDate();
      this.formatSelectedDate();
    }
    this.moodDetails = new Map<number, string>();
    this.moodDetails.set(1, 'schlecht');
    this.moodDetails.set(2, 'nicht gut');
    this.moodDetails.set(3, 'ok');
    this.moodDetails.set(4, 'gut');
    this.moodDetails.set(5, 'super');


  }
  formatSelectedDate() {
    // if(moment(this.selectedDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
    //   this.selectedDateFormatted = this.contentTranslation.translateContent('Mood today');
    // } else {
      this.selectedDateFormatted = moment(this.selectedDate).format('dd, ll')
    // }
  }

  updateFormattedDate(event) {
    this.selectedDate = event;
    this.formatSelectedDate();
  }
  hideError() {
    this.errorVisible = false;
  }

  goNext() {
    if (!this.chosenMood) {
      this.errorVisible = true;
      return;
    }

    var me = this;
    this.stats.getUserStats(moment(this.selectedDate.toISOString()).format('YYYY-MM-DD')).then((stats: UserStats) => {
      stats.mood = this.chosenMood;
      stats.moodFeedback = this.moodFeedback;
      this.events.publish('mood:tracked')

      me.stats.updateData(stats);
      me.navCtrl.pop();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppMoodUpdatePage');
  }

  updateMood(mood: number) {
    this.chosenMood = mood;
    this.errorVisible = false;
  }

  openedPopover: any;
  openDatePickerPopover(event) {
    console.log('here');
    this.openedPopover = this.popoverCtrl.create(
      DatePickerPopoverPage,
      {
        pastDateSelect: true,
        valueUpdated: (selectedDate) => {
          console.log(selectedDate);
          this.selectedDate = moment(selectedDate).toDate();
          this.formatSelectedDate();
        }
      },
      {cssClass: 'date-picker-popover-container'}
    );
    this.openedPopover.present({
      ev: event,
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-mood-update/app-mood-update.ts